import React from 'react';

interface TimeMachineProps {
    width?: string;
    height?: string;
    fill?: string;
}

const TimeMachine = ({
    width = '100%',
    height = '100%',
    fill = '#0000FF',
}: TimeMachineProps) => (
    <svg
        x="0px" y="0px"
        width={width} height={height}
        viewBox="0 0 48 48">
        <g
            transform="translate(0, 0)"
            fill={fill}
        >
            <path
                d="M40.979,7.047A23.848,23.848,0,0,0,24.011.01H24A24,24,0,0,0,0,24a2,2,0,0,0,2,2H2a2,2,0,0,0,2-2A20,20,0,0,1,24,4.01h.01a20,20,0,0,1-.009,40h-.009a20.04,20.04,0,0,1-10.74-3.169l3.254-2.76a1,1,0,0,0-.378-1.727L4.742,33.183a1,1,0,0,0-1.261,1.088L4.939,45.865a1,1,0,0,0,1.639.638l3.488-2.959A24.085,24.085,0,0,0,23.989,48.01H24A24,24,0,0,0,40.979,7.047Z"
                fill="#444444"></path>
            <path data-color="color-2"
                d="M38.5,25.5a1.5,1.5,0,0,0,0-3l-12.567-.433L25.5,9.5a1.5,1.5,0,0,0-3,0L22,24a2,2,0,0,0,2,2Z"
                fill="#444444"></path>
        </g>
    </svg>
);

export default TimeMachine;
